import React, { Component } from 'react';
import * as R from 'ramda';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { FormattedTag } from 'core/components';
import { createUrlSlug } from 'core/helpers';
import { IconArrowDown } from 'components/icons/icons-faq/icon-arrow-down';
import colors from 'customizations/js/color-variables';
import { fromEvent } from 'rxjs';
import { producerIcons, UnknownProducerIcon } from '../producer-icons';

import './producers.scss';

export class Producers extends Component {
  static propTypes = {
    filterProducers: PropTypes.arrayOf(PropTypes.string).isRequired,
    producers: PropTypes.arrayOf(PropTypes.string),
    setAllProducers: PropTypes.func.isRequired,
    setProducers: PropTypes.func.isRequired,
    filterCategory: PropTypes.string.isRequired,
  };

  static defaultProps = {
    producers: [],
  };

  state = {
    isAllProducersShown: false,
    hiddenItemsCount: 0,
  }

  resizeWindowSubscription;

  componentDidMount() {
    this.updateHiddenItemsCount();

    this.resizeWindowSubscription = fromEvent(window, 'resize')
      .subscribe(this.updateHiddenItemsCount);
  }

  componentDidUpdate({ filterCategory: prevFilterCategory }) {
    const { filterCategory } = this.props;

    if (filterCategory !== prevFilterCategory) {
      this.updateHiddenItemsCount();

      this.resizeWindowSubscription = fromEvent(window, 'resize')
        .subscribe(this.updateHiddenItemsCount);
    }
  }

  componentWillUnmount() {
    if (this.resizeWindowSubscription) {
      this.resizeWindowSubscription.unsubscribe();
    }
  }

  updateHiddenItemsCount = () => {
    const { hiddenItemsCount: hiddenItemsCountState } = this.state;
    const hiddenItemsCount = R.reject(({ offsetTop, offsetHeight }) => offsetTop < offsetHeight, document.querySelectorAll('.producers-item')).length;

    if (hiddenItemsCount !== hiddenItemsCountState) {
      this.setState({ hiddenItemsCount });
    }
  }

  toggleProducers = () => (
    this.setState(prevState => ({
      isAllProducersShown: !prevState.isAllProducersShown,
    }))
  );

  render() {
    const {
      producers,
      filterProducers,
      setAllProducers,
      setProducers
    } = this.props;
    const { isAllProducersShown, hiddenItemsCount } = this.state;
    const isAllProducersChoose = filterProducers.length === producers.length;

    return (
      <div className={classNames('producers-wrapper d-none d-md-flex overflow-hidden position-relative rounded',
        { 'mx-sm-2_5 mx-lg-5': !isAllProducersShown },
        { 'all-shown px-sm-2_5 px-lg-5 bg-dark-black w-100': isAllProducersShown })}
      >

        <div className={classNames('producers-block w-100 overflow-hidden pt-2_5',
          { 'shown pb-1_25': isAllProducersShown },
          { 'mb-1_5': !isAllProducersShown })}
        >
          <FormattedTag
            tag={Button}
            color="link"
            onClick={setAllProducers}
            onKeyPress={setAllProducers}
            id="games.providers.all"
            className={classNames('all-btn bg-white-10 text-decoration-none text-capitalize mr-0_5 mr-lg-1_25',
              { 'active text-white': isAllProducersChoose },
              { 'font-weight-normal text-white-70': !isAllProducersChoose })}
          />

          {hiddenItemsCount > 0 && (
            <span
              role="button"
              tabIndex="0"
              onClick={this.toggleProducers}
              onKeyPress={this.toggleProducers}
              className={classNames('bg-white-10 flex-shrink-0 game-producer float-right all-providers-btn d-inline-flex align-items-center px-1_5 align-items-center justify-content-between',
                { active: isAllProducersShown })}
            >
              <span className="text-white font-weight-semi-bold">
                <FormattedTag id="games.all-providers" className="text-white text-capitalize mr-1" />
                {!!filterProducers.length && <span>({filterProducers.length})</span>}
              </span>

              <IconArrowDown className="icon-rotate" color={isAllProducersShown ? colors.white : colors.white60} />
            </span>
          )}

          {producers && !!producers.length && producers.map((producer) => {
            const Icon = producerIcons[createUrlSlug(producer)] || UnknownProducerIcon;
            const isProducerActive = filterProducers.includes(producer);

            return (
              <div
                key={producer}
                role="button"
                tabIndex="0"
                onClick={setProducers}
                onKeyPress={setProducers}
                data-producer={producer}
                className={classNames('d-inline-flex align-items-center game-producer bg-white-10 px-1 px-lg-1_5 mr-0_5 producers-item mb-1_25', {
                  'producer-not-include mr-lg-1_25': !isProducerActive,
                  'active mr-lg-1': isProducerActive,
                })}
              >
                <Icon className="producer-icon" />

                <span className={classNames('ml-0_75 ml-lg-1 game-producer-name text-nowrap', {
                  'text-white-70': !isProducerActive,
                  'text-white font-weight-semi-bold': isProducerActive,
                })}
                >
                  {producer}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

